export default __webpack_public_path__ + "static/media/manageac_navicon.b6d214ba.svg";